export default __webpack_public_path__ + "static/media/laconic_small.cc0a9a57.jpg";